import spaceItIcon from '../images/space_it.svg';
import spaceHrIcon from '../images/space_hr.svg';
import spaceFacilityIcon from '../images/space_facility.svg';
import spaceFinanceIcon from '../images/space_finance.svg';
import spaceBusinessIcon from '../images/space_business.svg';
import spaceLegalIcon from '../images/space_legal.svg';
import spaceCustomerServiceIcon from '../images/space_customer_service.svg';
import spaceMarketingIcon from '../images/space_marketing.svg';

// Cross-space links carry a per-space-type icon file in iconPath
// (icons/ssp/space_<type>.svg). Resolve the bundled client asset by the type token so
// the SVG (with its own baked-in color) can be rendered directly.
// Shared by <Toolbox> and <ServiceCatalog>/scItem.
const SPACE_TYPE_ICONS = {
  it: spaceItIcon,
  hr: spaceHrIcon,
  facility: spaceFacilityIcon,
  finance: spaceFinanceIcon,
  business: spaceBusinessIcon,
  legal: spaceLegalIcon,
  customer_service: spaceCustomerServiceIcon,
  marketing: spaceMarketingIcon,
  other: spaceBusinessIcon
};

// [a-z_]+ so multi-word tokens like "customer_service" match
const SPACE_ICON_FILE_REGEX = /space_([a-z_]+)\.svg/;

// Returns the bundled icon URL for a cross-space link's iconPath, or null if it isn't one.
export default function getSpaceLinkIcon(iconPath) {
  const match = SPACE_ICON_FILE_REGEX.exec(iconPath || '');
  return match ? SPACE_TYPE_ICONS[match[1]] || null : null;
}



// WEBPACK FOOTER //
// ./utils/spaceLinkIcon.js